import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Card, Spinner } from 'react-bootstrap';
import { FaBarcode, FaBox, FaCheckCircle, FaShoppingCart } from 'react-icons/fa';

/**
 * Componente para mostrar una tarjeta de producto en el modal de selección
 * Soporta caracteres Unicode (acentos, ñ, símbolos especiales)
 */
const ProductoTarjeta = ({ producto, agregado, cargandoEsteProducto, onAgregarProducto }) => {
    return (
        <Card
            className="h-100 shadow-sm"
            style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.15)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
            }}
        >
            <Card.Body className="p-3">
                {/* Badge de estado */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <Badge
                        bg={agregado ? "success" : "secondary"}
                        pill
                        style={{ fontSize: '0.65rem' }}
                    >
                        {agregado ? <><FaCheckCircle className="me-1" /> Agregado</> : <FaBox className="me-1" />}
                    </Badge>
                    <Badge
                        bg="light"
                        text="dark"
                        style={{ fontSize: '0.7rem', fontWeight: '600' }}
                    >
                        <FaBarcode className="me-1" />
                        {producto.vCodigoBarras}
                    </Badge>
                </div>

                {/* Nombre del producto - Nombre completo sin truncar */}
                <h6
                    className="mb-2"
                    style={{
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        color: '#2c3e50',
                        minHeight: '40px',
                        wordWrap: 'break-word',
                        overflow: 'visible',
                        display: 'block',
                        lineHeight: '1.4',
                    }}
                >
                    {producto.vNombreProducto}
                </h6>

                {/* Precio */}
                <div className="mb-3">
                    <span style={{ fontSize: '0.75rem', color: '#7f8c8d' }}>Precio Unitario</span>
                    <div style={{ fontSize: '1.3rem', fontWeight: '700', color: '#009bdb' }}>
                        ${producto.dTotal?.toFixed(2)}
                    </div>
                </div>

                {/* Botón de acción */}
                <Button
                    size="sm"
                    variant={agregado ? "warning" : "primary"}
                    className="w-100"
                    onClick={() => onAgregarProducto(producto.idProducto)}
                    disabled={cargandoEsteProducto}
                    style={{
                        borderRadius: '6px',
                        fontWeight: '500',
                        backgroundColor: agregado ? '#ffc107' : '#009bdb',
                        borderColor: agregado ? '#ffc107' : '#009bdb',
                    }}
                >
                    {cargandoEsteProducto ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Agregando...
                        </>
                    ) : agregado ? (
                        <>
                            <FaShoppingCart className="me-2" />
                            Agregar otra vez
                        </>
                    ) : (
                        <>
                            <FaShoppingCart className="me-2" />
                            Agregar
                        </>
                    )}
                </Button>
            </Card.Body>
        </Card>
    );
};

ProductoTarjeta.propTypes = {
    producto: PropTypes.shape({
        idProducto: PropTypes.number.isRequired,
        vNombreProducto: PropTypes.string.isRequired,
        vCodigoBarras: PropTypes.string,
        dTotal: PropTypes.number
    }).isRequired,
    agregado: PropTypes.bool.isRequired,
    cargandoEsteProducto: PropTypes.bool.isRequired,
    onAgregarProducto: PropTypes.func.isRequired
};

export default ProductoTarjeta;